import React from 'react';
import { message } from 'antd';
import { Button, ButtonType } from 'syngenta-digital-cropwise-react-ui-kit';
import CloseIcon from 'components/Icons/CloseIcon';
import { RECORD_SOURCE_MESSAGE_KEY } from 'screens/Applications&WorkOrders/Components/DetailsTabs/components/DetailsTab/components/RecordSourceButton/constants/messageKey';
import { OperationType } from 'screens/Applications&WorkOrders/RouteAdmin';

interface MessageContentProps {
  type: OperationType;
  onReturn: () => void;
}

const MessageContent: React.FC<MessageContentProps> = ({ type, onReturn }) => {
  const onClose = () => {
    message.destroy(RECORD_SOURCE_MESSAGE_KEY);
  };

  const onReturnClick = () => {
    // This will be replaced with actual navigation logic in the future
    message.destroy(RECORD_SOURCE_MESSAGE_KEY);
    onReturn();
  };

  return (
    <div className="flex items-center gap-4">
      <div className="text-sm font-medium">Viewing record source.</div>
      <div className="flex items-center bg-neutral-90">
        <Button
          size="small"
          ghost
          type={ButtonType.success}
          onClick={onReturnClick}
        >
          Return to{' '}
          {type === OperationType.APPLICATION ? 'Application' : 'Work Order'}
        </Button>
      </div>
      <button aria-label="Close" type="button" onClick={onClose}>
        <CloseIcon fill="#fff" />
      </button>
    </div>
  );
};

export default MessageContent;
